export enum ItemUnit {
	milli_liter = 'ml',
	liter = 'l',
	milli_gram = 'mg',
	gram = 'g',
	kilo_gram = 'kg',
	pieces = 'pcs',
}
